require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-js-reduce-with-video.json") })
        }
      }, "path---blog-js-reduce-with-video");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-js-reduce-with-video!./.cache/json/blog-js-reduce-with-video.json
// module id = 908
// module chunks = 231608221292675